import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import LaunchIcon from '@mui/icons-material/Launch';

import CommonMessages from '~/core/commonMessages';
import { BettingOddPartner } from '~/core/types';

import { BettingOddsLogoLink, OddsProviderCard, OddsProviderLabel } from './styles';

type Props = {
    bettingOddPartner: BettingOddPartner;
};

const OddsProviderDayCard: FC<Props> = ({ bettingOddPartner }) => {
    return (
        <>
            <OddsProviderCard $partner={bettingOddPartner}>
                <OddsProviderLabel $partner={bettingOddPartner}>
                    <FormattedMessage {...CommonMessages.gameInformationDescriptions.oddsBy} />
                </OddsProviderLabel>
                <BettingOddsLogoLink $partner={bettingOddPartner} href={bettingOddPartner.siteUrl} target="_blank">
                    <img src={bettingOddPartner.imageUrl} alt={bettingOddPartner.name} />
                    <LaunchIcon />
                </BettingOddsLogoLink>
            </OddsProviderCard>
        </>
    );
};

export default OddsProviderDayCard;
